import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { waLink } from "../../brand";

/**
 * Reusable hero header for inner pages.
 * Keeps exact visual language from Hero.jsx (eyebrow, gradient text, glow halo).
 */
export default function PageHero({
  eyebrow,
  title,
  highlight,
  titleSuffix = ".",
  description,
  primaryCta = { to: "/contacto", label: "Agenda una consultoría" },
  secondaryCta = { href: waLink(), label: "Hablar por WhatsApp" },
  rightSlot = null,
}) {
  return (
    <section className="relative pt-32 sm:pt-36 lg:pt-40 pb-16 lg:pb-24 overflow-hidden">
      <div className="absolute inset-0 bg-radial-orange pointer-events-none" />
      <div
        className="absolute -top-24 left-1/2 -translate-x-1/2 w-[1100px] h-[900px] rounded-full opacity-40 pointer-events-none"
        style={{
          background:
            "radial-gradient(closest-side, rgba(255,138,0,0.18), transparent 70%)",
        }}
      />
      <div className="absolute inset-0 grain pointer-events-none" />

      <div className="container-x relative">
        <div className={`grid ${rightSlot ? "lg:grid-cols-12 gap-10 lg:gap-14 items-center" : ""}`}>
          <div className={`reveal ${rightSlot ? "lg:col-span-7" : "max-w-4xl"}`}>
            {eyebrow && <div className="eyebrow mb-6">{eyebrow}</div>}
            <h1 className="font-display font-extrabold text-white text-[2.4rem] sm:text-[3rem] lg:text-[4rem] leading-[1.04] tracking-tighter">
              {title}
              {highlight && (
                <>
                  {" "}
                  <span className="text-gradient text-glow">{highlight}</span>
                </>
              )}
              {titleSuffix}
            </h1>
            {description && (
              <p className="mt-6 text-zinc-400 text-lg sm:text-xl max-w-2xl leading-relaxed">
                {description}
              </p>
            )}

            <div className="mt-8 flex flex-wrap items-center gap-3">
              {primaryCta && (
                <Link to={primaryCta.to} className="btn-primary" data-testid="page-hero-primary-cta">
                  {primaryCta.label}
                  <ArrowRight className="w-4 h-4" />
                </Link>
              )}
              {secondaryCta && (
                <a
                  href={secondaryCta.href}
                  target="_blank"
                  rel="noreferrer"
                  className="btn-secondary"
                  data-testid="page-hero-secondary-cta"
                >
                  <span className="w-2 h-2 rounded-full bg-[#25D366] pulse-dot" />
                  {secondaryCta.label}
                </a>
              )}
            </div>
          </div>

          {rightSlot && <div className="lg:col-span-5 reveal">{rightSlot}</div>}
        </div>
      </div>
    </section>
  );
}
